__turbopack_context__.v({
  "perguntasRespostas": "XUxFcW_perguntasRespostas",
  "title": "XUxFcW_title",
  "uiContainer": "XUxFcW_uiContainer",
});
